import { render } from "./VideoConversation.vue?vue&type=template&id=3dbceec0"
import script from "./VideoConversation.vue?vue&type=script&lang=js"
export * from "./VideoConversation.vue?vue&type=script&lang=js"
script.render = render

export default script